// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { home16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-home': IconHome;
    }
}

/**
 * The icon component for the 'home' icon
 */
export class IconHome extends IconSvg {
    public constructor() {
        super(home16X16);
    }
}

registerIconSvg('icon-home', IconHome);
export const iconHomeTag = 'nimble-icon-home';
